import { baseApi } from '@shared/utils/api/configs/rtkBaseQueryDemo';

import {
  getClinicList,
  getCollectionList,
  getLocationList,
  getMedicationList,
  getMedRefillInstitutions,
  getMedRefillPaymentModes,
  getPrescriptionDetails,
  getPrescriptionList,
  getPublicClinicList,
  getPublicCollectionList,
  getPublicHolidays,
  getPublicLocationList,
  getPublicMedicationList,
  getPublicMedRefillInstitutions,
  getPublicMedRefillPaymentModes,
  submitMedRefillRequest,
  submitPublicMedRefillRequest,
  TAG_MEDREFILL_CLINIC_LIST,
  TAG_MEDREFILL_COLLECTION_LIST,
  TAG_MEDREFILL_INSTITUTIONS,
  TAG_MEDREFILL_LOCATION_LIST,
  TAG_MEDREFILL_MEDICATION_LIST,
  TAG_MEDREFILL_PAYMENT_MODES,
  TAG_MEDREFILL_PRESCRIPTION_DETAILS,
  TAG_MEDREFILL_PRESCRIPTION_LIST,
  TAG_MEDREFILL_PUBLIC_HOLIDAYS,
  TAG_PUBLIC_MEDREFILL_CLINIC_LIST,
  TAG_PUBLIC_MEDREFILL_COLLECTION_LIST,
  TAG_PUBLIC_MEDREFILL_INSTITUTIONS,
  TAG_PUBLIC_MEDREFILL_LOCATION_LIST,
  TAG_PUBLIC_MEDREFILL_MEDICATION_LIST,
  TAG_PUBLIC_MEDREFILL_PAYMENT_MODES,
} from './endpoints';

export const medRefillApis = baseApi
  .injectEndpoints({
    endpoints: (builder) => ({
      getClinicList: getClinicList(builder),
      getCollectionList: getCollectionList(builder),
      getLocationList: getLocationList(builder),
      getMedicationList: getMedicationList(builder),
      getMedRefillInstitutions: getMedRefillInstitutions(builder),
      getMedRefillPaymentModes: getMedRefillPaymentModes(builder),
      getPrescriptionDetails: getPrescriptionDetails(builder),
      getPrescriptionList: getPrescriptionList(builder),
      getPublicClinicList: getPublicClinicList(builder),
      getPublicCollectionList: getPublicCollectionList(builder),
      getPublicHolidays: getPublicHolidays(builder),
      getPublicLocationList: getPublicLocationList(builder),
      getPublicMedicationList: getPublicMedicationList(builder),
      getPublicMedRefillInstitutions: getPublicMedRefillInstitutions(builder),
      getPublicMedRefillPaymentModes: getPublicMedRefillPaymentModes(builder),
      submitMedRefillRequest: submitMedRefillRequest(builder),
      submitPublicMedRefillRequest: submitPublicMedRefillRequest(builder),
    }),
  })
  .enhanceEndpoints({
    addTagTypes: [
      TAG_MEDREFILL_INSTITUTIONS,
      TAG_PUBLIC_MEDREFILL_INSTITUTIONS,
      TAG_MEDREFILL_PAYMENT_MODES,
      TAG_PUBLIC_MEDREFILL_PAYMENT_MODES,
      TAG_MEDREFILL_MEDICATION_LIST,
      TAG_PUBLIC_MEDREFILL_MEDICATION_LIST,
      TAG_MEDREFILL_COLLECTION_LIST,
      TAG_PUBLIC_MEDREFILL_COLLECTION_LIST,
      TAG_MEDREFILL_LOCATION_LIST,
      TAG_PUBLIC_MEDREFILL_LOCATION_LIST,
      TAG_MEDREFILL_CLINIC_LIST,
      TAG_PUBLIC_MEDREFILL_CLINIC_LIST,
      TAG_MEDREFILL_PRESCRIPTION_DETAILS,
      TAG_MEDREFILL_PUBLIC_HOLIDAYS,
      TAG_MEDREFILL_PRESCRIPTION_LIST,
    ],
  });

export const {
  useGetClinicListQuery,
  useGetCollectionListQuery,
  useGetLocationListQuery,
  useGetMedicationListQuery,
  useGetMedRefillInstitutionsQuery,
  useGetMedRefillPaymentModesQuery,
  useGetPrescriptionDetailsQuery,
  useGetPrescriptionListQuery,
  useGetPublicClinicListQuery,
  useGetPublicCollectionListQuery,
  useGetPublicHolidaysQuery,
  useGetPublicLocationListQuery,
  useGetPublicMedicationListQuery,
  useGetPublicMedRefillInstitutionsQuery,
  useGetPublicMedRefillPaymentModesQuery,
  useLazyGetLocationListQuery,
  useLazyGetPublicLocationListQuery,
  useSubmitMedRefillRequestMutation,
  useSubmitPublicMedRefillRequestMutation,
} = medRefillApis;
